/*
 * @Description: 地图样式切换（纯净 / 普通 / 卫星）。
 *   纯净：whitesmoke + 无 point；普通：normal + 含 point；卫星：叠加卫星图层。
 */
import { CockpitMapStyle, MAP_FEATURES, MAP_FEATURES_FULL } from '../constants'

/** 卫星图层引用容器（各地图组件各持一个，便于增删） */
export interface SatelliteLayerRef {
  current: any
}

/** 地图样式持久化 key（驾驶舱与回放页共用，下次进入沿用上次选择） */
const MAP_STYLE_STORAGE_KEY = 'COCKPIT_MAP_STYLE'
const VALID_MAP_STYLES: CockpitMapStyle[] = ['clean', 'standard', 'satellite']

/** 读取持久化的地图样式（无 / 非法时默认 clean） */
export function loadMapStyle(): CockpitMapStyle {
  try {
    const v = window.localStorage.getItem(MAP_STYLE_STORAGE_KEY)
    if (v && VALID_MAP_STYLES.includes(v as CockpitMapStyle)) {
      return v as CockpitMapStyle
    }
  } catch (e) {
    // localStorage 不可用（隐私模式等）兜底
  }
  // 首次进入（无持久化值）默认普通模式
  return 'standard'
}

/** 持久化地图样式 */
export function saveMapStyle(style: CockpitMapStyle): void {
  try {
    window.localStorage.setItem(MAP_STYLE_STORAGE_KEY, style)
  } catch (e) {
    // 忽略写入失败
  }
}

/**
 * 把地图样式应用到 AMap 实例。
 *
 * @param map - AMap.Map 实例
 * @param AMap - AMap 命名空间（window.AMap）
 * @param style - 目标样式
 * @param satelliteRef - 卫星图层引用（用于增删卫星图层）
 */
export function applyMapStyle(
  map: any,
  AMap: any,
  style: CockpitMapStyle,
  satelliteRef: SatelliteLayerRef
): void {
  if (!map || !AMap) return

  if (style === 'satellite') {
    if (!satelliteRef.current) {
      satelliteRef.current = new AMap.TileLayer.Satellite()
      map.add(satelliteRef.current)
    }
    // 卫星底图上显示路网/标注
    map.setFeatures(MAP_FEATURES_FULL)
    return
  }

  // 非卫星：移除卫星图层
  if (satelliteRef.current) {
    map.remove(satelliteRef.current)
    satelliteRef.current = null
  }

  // 普通与纯净底图样式一致（whitesmoke），区别仅在普通额外显示 point 标注
  map.setMapStyle('amap://styles/whitesmoke')
  map.setFeatures(style === 'standard' ? MAP_FEATURES_FULL : MAP_FEATURES)
}
